module.exports = __webpack_public_path__ + "static/media/team2.15d802af.jpeg";